<template>
	<tr>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					placeholder="Select mc"
					type="number"
					:set-input-value="item.mc"
					@updateInput="onInput($event, 'mc')"
					is-off-style
			></field>
		</td>
	  <td>
		  <field
				  margin="0"
				  padding="10px 0"
				  width="150px"
				  label=""
				  placeholder="Select phone"
				  :set-input-value="item.phone"
				  @updateInput="onInput($event, 'phone')"
				  is-off-style
		  ></field>
	  </td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					placeholder="Select truksqty"
					:set-input-value="item.truksqty"
					@updateInput="onInput($event, 'truksqty')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					placeholder="Select email"
					:set-input-value="item.email"
					@updateInput="onInput($event, 'email')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					placeholder="Select contactname"
					:set-input-value="item.contactname"
					@updateInput="onInput($event, 'contactname')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					placeholder="Select carriername"
					:set-input-value="item.carriername"
					@updateInput="onInput($event, 'carriername')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					placeholder="Select aubreycomment"
					:set-input-value="item.aubreycomment"
					@updateInput="onInput($event, 'aubreycomment')"
					is-off-style
			></field>
		</td>
		<td>
			<field
					margin="0"
					padding="10px 0"
					width="150px"
					label=""
					placeholder="Select error"
					:set-input-value="item.error"
					@updateInput="onInput($event, 'error')"
					is-off-style
			></field>
		</td>
	</tr>
</template>

<script>

export default {
	name: "TableClientsTr",
	props: {
		item: Object,
		permissions: Object,
		checkClasses: Object,
		filterClassesActive: Function,
		idx: Number
	},
	methods: {
		onInput({ value }, key) {
			this.$set(this.item, `${ key }`, value);
		},
		onDate(date) {
			this.$set(this.item, 'date', date);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "tableTr";
</style>

<style lang="scss">
@import "tableTrGlobal";
</style>
